import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import "./Externallogin.css";
import logo from "../../../Assests/RebelSkool.png";
import axios from "axios";
import { Toast } from "primereact/toast";

const Externallogin = () => {
  const history = useHistory();
  const [emailId, setemailId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({ emailId: "", password: "" });
  const [message, setMessage] = useState({ text: "", type: "" });
  const toast = useRef(null);
  const validate = (name, value) => {
    if (!value.trim()) {
      return name === "emailId"
        ? "Enter your emailId."
        : "Enter your password.";
    }
    return "";
  };
  useEffect(() => {
    const userDetails = localStorage.getItem("RBLExternalUserDetails");
    if (userDetails) {
      history.push("/external/dashboard");
    } else {
      return;
    }
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    setMessage({ text: "", type: "" });

    const nextErrors = {
      emailId: validate("emailId", emailId),
      password: validate("password", password)
    };
    setErrors(nextErrors);

    if (nextErrors.emailId) {
      document.getElementById("emailId").focus();
      return;
    }
    if (nextErrors.password) {
      document.getElementById("password").focus();
      return;
    }
    const userdetails = {
      emailID: emailId,
      password: password,
      externalUser: true
    };
    if (userdetails.emailID !== "" && userdetails.password !== "") {
      axios
        .post("/user/external/login", userdetails)
        .then((res) => {
          if (res.data.emailID === null || res.data.userName === null) {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "userName or emailID is Invalid",
              life: 3000
            });
          }
          if (res.data.emailID !== null && res.data.userName !== null) {
            const userAuthKey = res.headers["user-session-auth-key"];
            history.push("/external/dashboard");
            res.data["User-Session-Auth-Key"] = userAuthKey;
            localStorage.setItem(
              "RBLExternalUserDetails",
              JSON.stringify(res.data)
            );
          }
        })
        .catch((err) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: err || "Login failed",
            life: 3000
          });
        });
    }
  };

  return (
    <div className="externallogin-container">
      <Toast ref={toast} />
      <div className="externallogin-card">
        <img
          className="externallogin-logo"
          src={logo}
          alt="RebelSkool"
          width="228"
          height="60"
        />

        {/*  <h1 className="externallogin-title">Sign in</h1> */}

        <form className="externallogin-form" onSubmit={handleLogin} noValidate>
          <div className="externallogin-group">
            <label htmlFor="emailId" className="externallogin-label">
              Email ID
            </label>
            <input
              type="text"
              id="emailId"
              name="emailId"
              className="externallogin-input"
              value={emailId}
              onChange={(e) => {
                setemailId(e.target.value);
                if (errors.emailId) setErrors({ ...errors, emailId: "" });
              }}
              onBlur={(e) =>
                setErrors({
                  ...errors,
                  emailId: validate("emailId", e.target.value)
                })
              }
            />
            {errors.emailId && (
              <p className="externallogin-error" id="emailId-error">
                {errors.emailId}
              </p>
            )}
          </div>

          <div className="externallogin-group">
            <label htmlFor="password" className="externallogin-label">
              Password
            </label>
            <div className="externallogin-control">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                className="externallogin-input externallogin-input--with-action"
                autoComplete="current-password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (errors.password) setErrors({ ...errors, password: "" });
                }}
                onBlur={(e) =>
                  setErrors({
                    ...errors,
                    password: validate("password", e.target.value)
                  })
                }
              />
              <button
                type="button"
                className="externallogin-toggle"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
            {errors.password && (
              <p className="externallogin-error" id="password-error">
                {errors.password}
              </p>
            )}
          </div>

          {message.text && (
            <p
              className={`externallogin-message ${message.type}`}
              role={message.type === "error" ? "alert" : "status"}
            >
              {message.text}
            </p>
          )}

          <button type="submit" className="externallogin-button">
            Sign in
          </button>
        </form>
      </div>
    </div>
  );
};

export default Externallogin;
